import { render, staticRenderFns } from "./HiddenForm.vue?vue&type=template&id=97351f4a&scoped=true&lang=pug"
import script from "./HiddenForm.vue?vue&type=script&lang=js"
export * from "./HiddenForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97351f4a",
  null
  
)

export default component.exports